// extracted by mini-css-extract-plugin
module.exports = {"separator":"MiddotSeparator_separator__us040","hiddenMobile":"MiddotSeparator_hiddenMobile__1npBv","visibleMobile":"MiddotSeparator_visibleMobile__sWQVS"};